
    import './styles.scoped.css';
    export default {
  "body-cell": "awsui_body-cell_c6tup_c7aag_9",
  "body-cell-wrap": "awsui_body-cell-wrap_c6tup_c7aag_18",
  "body-cell-first-row": "awsui_body-cell-first-row_c6tup_c7aag_31",
  "body-cell-last-row": "awsui_body-cell-last-row_c6tup_c7aag_34",
  "body-cell-selected": "awsui_body-cell-selected_c6tup_c7aag_37",
  "body-cell-next-selected": "awsui_body-cell-next-selected_c6tup_c7aag_56",
  "body-cell-prev-selected": "awsui_body-cell-prev-selected_c6tup_c7aag_60"
};
  